import axios, { AxiosError } from 'axios';
import { onReqError, onRequest } from './onRequest';
import { onResError, onResponse } from './onResponse';

const instance = axios.create({
  baseURL: process.env.REACT_APP_JEBS_API_URL,
  withCredentials: true,
  timeout: 30000,
  headers: {
    Accept: '*/*',
    'Content-Type': 'application/json',
  },
});

// 요청 인터셉터
instance.interceptors.request.use(onRequest, onReqError);

// 500 에러 테스트: MSW(__errorTest) 사용 → src/mocks/ 참조

// 1단계: GET 자동 재시도 (지수 백오프, 최대 2회)
// - 재시도 대상: GET 요청 + (500번대 || 네트워크 에러)
// - POST/PUT/DELETE는 중복 처리 위험으로 재시도하지 않음
const MAX_RETRY = 2;
const BACKOFF_BASE_MS = 300;
const JITTER_MAX_MS = 200;

instance.interceptors.response.use(onResponse, async (error: AxiosError) => {
  const config = error.config as any;
  if (!config) return Promise.reject(error);

  const isGet = config.method === 'get';
  const isServerError = !error.response || error.response.status >= 500;

  if (!config.__retryCount) config.__retryCount = 0;

  if (isGet && isServerError && config.__retryCount < MAX_RETRY) {
    config.__retryCount++;
    const delay =
      BACKOFF_BASE_MS * Math.pow(2, config.__retryCount - 1) +
      Math.random() * JITTER_MAX_MS;
    await new Promise((r) => setTimeout(r, delay));
    return instance(config);
  }

  return Promise.reject(error);
});

// 2단계: 최종 에러 처리 (공사중 페이지, 401, 403 등)
instance.interceptors.response.use(undefined, onResError);

export default instance;
